/**
 * 账户中心专用图标 — 与顶栏 / AccountShell 共用 @xt/Nav 图标，保持视觉一致。
 */
import React from "react";

export {
  IconNavUserCircle,
  IconNavShieldCheck,
  IconNavBadgeCheck,
  IconNavSlidersHorizontal,
  IconNavPercent,
  IconNavUserPlus,
  IconNavLogOut,
  IconNavFolderMinus,
  IconNavInfo,
} from "@xt/Nav";

function AccountIconBase({ className, children }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {children}
    </svg>
  );
}

/** lucide settings — overview / preferences shortcut */
export function IconNavSettings(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </AccountIconBase>
  );
}

/** lucide credit-card — spikex card */
export function IconNavCreditCard(props) {
  return (
    <AccountIconBase {...props}>
      <rect width="20" height="14" x="2" y="5" rx="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </AccountIconBase>
  );
}

/** lucide pencil — edit profile */
export function IconNavPencil(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
      <path d="m15 5 4 4" />
    </AccountIconBase>
  );
}

/** lucide eye */
export function IconNavEye(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
      <circle cx="12" cy="12" r="3" />
    </AccountIconBase>
  );
}

/** lucide eye-off */
export function IconNavEyeOff(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
      <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
      <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
      <path d="m2 2 20 20" />
    </AccountIconBase>
  );
}

/** lucide mail — security center */
export function IconSecMail(props) {
  return (
    <AccountIconBase {...props}>
      <rect width="20" height="16" x="2" y="4" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </AccountIconBase>
  );
}

/** lucide phone — security center */
export function IconSecPhone(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </AccountIconBase>
  );
}

/** lucide key-round — anti-phishing */
export function IconSecKeyRound(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
      <circle cx="16.5" cy="7.5" r="1" />
    </AccountIconBase>
  );
}

/** lucide zap — quick withdrawal */
export function IconSecZap(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
    </AccountIconBase>
  );
}

/** lucide lock — login password */
export function IconSecLock(props) {
  return (
    <AccountIconBase {...props}>
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </AccountIconBase>
  );
}

/** lucide trash-2 — close account */
export function IconSecTrash(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M3 6h18" />
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      <line x1="10" x2="10" y1="11" y2="17" />
      <line x1="14" x2="14" y1="11" y2="17" />
    </AccountIconBase>
  );
}

/** lucide laptop — trusted devices */
export function IconSecLaptop(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9" />
      <path d="M22 16H2" />
    </AccountIconBase>
  );
}

/** lucide chevron-right — security activity rows */
export function IconSecChevronRight(props) {
  return (
    <AccountIconBase {...props}>
      <path d="m9 18 6-6-6-6" />
    </AccountIconBase>
  );
}

/** Spikex Card overview CTA chevron — Figma node 16413:25183 */
export function IconSpikexCardCtaChevron({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4.5 3L7.5 6L4.5 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** lucide landmark — fiat payment method */
export function IconPmLandmark(props) {
  return (
    <AccountIconBase {...props}>
      <line x1="3" x2="21" y1="22" y2="22" />
      <line x1="6" x2="6" y1="18" y2="11" />
      <line x1="10" x2="10" y1="18" y2="11" />
      <line x1="14" x2="14" y1="18" y2="11" />
      <line x1="18" x2="18" y1="18" y2="11" />
      <polygon points="12 2 20 7 4 7" />
    </AccountIconBase>
  );
}

/** lucide plus — add payment method */
export function IconPmPlus(props) {
  return (
    <AccountIconBase {...props}>
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </AccountIconBase>
  );
}
